module.exports = __webpack_public_path__ + "static/k-store-7-51314241e2cf20bc90b315680a01e9c8.jpg";